<template>
  <!-- name: '我要捐-捐衣列表页' -->
  <div class="clothesListWrap">
    <div class="searchBox">
      <form @submit.prevent="getListDemand" action="">
        <input
          type="search"
          placeholder="搜索项目"
          v-model="name"
          autocomplete="no"
          @keyup.13="getListDemand"
          @blur="getListDemand"
        />
      </form>

      <div class="selectBox">
        <div class="selectClass" @click="isShow = !isShow">
          {{ curSelect.name }}
          <img src="https://img.bbalt.cn/imgh5/donate/icon_narrow_down.svg" alt="" />
        </div>
        <ul v-show="isShow">
          <li
            :value="item.value"
            v-for="(item, index) in optionList"
            :key="index"
            @click="handleChange(item)"
          >
            {{ item.name }}
            <img
              v-if="item.value === curSelect.value"
              src="https://img.bbalt.cn/imgh5/donate/icon_tick.svg"
              alt=""
            />
          </li>
        </ul>
      </div>
    </div>

    <van-loading v-if="isShowLoading">加载中...</van-loading>
    <div class="listBox" v-else>
      <ul v-show="curDataList.length > 0">
        <li
          v-for="(item, index) in curDataList"
          :key="index"
          @click="
            $router.push({
              path: '/donateThird',
              query: {
                title: '项目详情',
                id: item.id,
                nextPath: '/donateSecond'
              },
            })
          "
        >
          <img
            :src="getFirstImage(item.picUrls)"
            alt=""
            class="imgClass"
            v-default-img="defaultImgUrl"
          />
          <div class="infoBox">
            <h5>{{ item.theme }}</h5>
            <div class="contentBox">
              <div class="labelBox">
                <span class="labelClass"
                  ><img src="https://img.bbalt.cn/imgh5/home/icon_place.svg" />{{
                    item.provinceName ? item.provinceName : "未知"
                  }}</span
                >
                <span class="labelClass"
                  ><img src="https://img.bbalt.cn/imgh5/home/icon_size.svg" />{{
                    item.sizeName
                  }}</span
                >
              </div>
              <span class="lackNumClass"
                >缺<span>{{ item.demandCount - item.donateCount }}</span
                >件</span
              >
            </div>
            <div class="progressBox">
              <div
                class="progressClass"
                :style="`width:${(item.donateCount / item.demandCount) * 100}%`"
              ></div>
            </div>
          </div>
          <!-- 上线项目 -->
          <div class="btnClass" v-show="item.status === 2">
            <img src="https://img.bbalt.cn/imgh5/donate/icon_cloth.svg" alt="" />
            我要捐衣
          </div>
          <!-- 完成项目 -->
          <div
            class="btnClass"
            v-show="item.status === 3"
            @click="
              $router.push({
                path: '/other',
                query: { title: '捐衣海报' },
              })
            "
          >
            <img src="https://img.bbalt.cn/imgh5/donate/icon_post.svg" alt="" />
            生成反馈海报
          </div>
        </li>
      </ul>
      <div class="noDataBox" v-show="curDataList.length === 0">
        <img src="https://img.bbalt.cn/imgh5/nodata.png" alt="" />
        暂无数据
      </div>
    </div>
    <van-loading v-if="isLazyLoad" />
    <div class="fixBox" style="display:none">
      <div class="titleBox">
        <img src="https://img.bbalt.cn/imgh5/donate/icon_register.svg" alt="" />
        登记我的可捐衣服
        <img
          src="https://img.bbalt.cn/imgh5/donate/icon_next.png"
          alt=""
          @click="
            $router.push({
              path: '/userCenterSecond',
              query: { title: '可捐衣物登记' },
            })
          "
        />
      </div>
      <p>暂时捐不出的衣物，可「登记可捐衣服」等待系统自动匹配提示</p>
    </div>
  </div>
</template>

<script>
import { listDemand } from "@/api/donate";
import mixin from "@/utils/mixin.js";
export default {
  mixins: [mixin],
  components: {},
  data() {
    return {
      optionList: [
        { name: "全部", value: "" },
        { name: "已完成", value: "3" },
        { name: "项目暂停", value: "4" },
        { name: "上线中", value: "2" },
      ],
      curSelect: { name: "全部", value: "" },
      isShow: false,
      listQuery: { pageNo: 1, pageSize: 10 },
      curDataList: [],
      name: "",
      total: 0,
      defaultImgUrl: `https://img.bbalt.cn/imgh5/user_default.svg`,
      isShowLoading: true,
      isLazyLoad: false,
    };
  },
  created() {
    this.getListDemand();
  },
  methods: {
    handleChange(item) {
      this.isShowLoading = true;
      this.curSelect = item;
      this.isShow = false;
      this.getListDemand();
    },
    async getListDemand(pageNo, isLazy) {
      if (isLazy) {
        this.isLazyLoad = true;
      }
      this.listQuery.pageNo = pageNo > 1 ? pageNo : this.listQuery.pageNo;
      const { content } = await listDemand({
        ...{ type: "1", name: this.name, status: this.curSelect.value },
        ...this.listQuery,
      });
      
      this.curDataList = isLazy
        ? [...this.curDataList, ...content.records]
        : content.records;
      this.total = content.total;
      this.isShowLoading = false;
      this.isLazyLoad = false;
    },
    getFirstImage(image) {
      if (image) {
        return image.split(',')[0]
      } else {
        return image;
      }
    }
  },
  mounted() {
    let dom = document.querySelector(".clothesListWrap");
    this.handleScrollLazy(
      dom,
      this.listQuery.pageNo,
      this.listQuery.pageSize,
      this.total,
      this.getListDemand
    );
  },
};
</script>

<style lang="scss" scoped>
.clothesListWrap {
  height: 78vh;
  width: 100%;
  overflow: auto;
  padding-bottom: 37px;
  .searchBox {
    margin: 32px;
    display: flex;
    justify-content: space-between;
    input {
      width: 480px;
      height: 72px;
      background: #eeeeee;
      border-radius: 36px;
      border: 1px solid #dddddd;
      background-image: url("https://img.bbalt.cn/imgh5/donate/icon_search.svg");
      background-repeat: no-repeat;
      background-size: 30px 30px;
      background-position: 32px 21px;
      padding-left: 78px;
      padding-right: 20px;
      &::placeholder {
        font-size: 28px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
    }

    .selectBox {
      width: 180px;
      height: 72px;
      position: relative;
      .selectClass {
        background: #eeeeee;
        border-radius: 36px;
        border: 1px solid #dddddd;
        position: absolute;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        font-size: 28px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #333333;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 30px;
          height: 30px;
          margin-left: 8px;
        }
      }
      ul {
        position: absolute;
        top: 88px;
        left: -30px;
        width: 208px;
        background: #eeeeee;
        border-radius: 24px;
        display: flex;
        flex-flow: column;
        li {
          padding-left: 32px;
          margin: 18px 0px;
          height: 36px;
          font-size: 28px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 36px;
          padding-right: 16px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          img {
            width: 30px;
            height: 30px;
          }
        }
      }
    }
  }

  .listBox {
    margin-bottom: 108px;
    min-height: 300px;
    ul {
      margin: 0px 32px;
      li {
        width: 686px;
        background: #ffffff;
        border-radius: 16px;
        margin-bottom: 32px;
        padding-bottom: 23px;
        .imgClass {
          width: 100%;
          height: 316px;
          border-radius: 16px 16px 0px 0px;
        }
        .infoBox {
          margin: 24px 32px;
          border-bottom: 1px solid #ededed;
          font-family: PingFangSC, PingFang SC;
          h5 {
            width: 618px;
            font-size: 30px;
            font-weight: 600;
            color: #333333;
            line-height: 40px;
          }
          .contentBox {
            margin-top: 16px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .labelBox {
              display: flex;
              .labelClass {
                padding: 0px 8px;
                height: 40px;
                background: #679fd2;
                border-radius: 4px;
                font-size: 22px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #ffffff;
                display: flex;
                align-items: center;
                justify-content: center;
                min-width: 110px;
                width: auto;
                margin-right: 8px;
                img {
                  width: 20px;
                  height: 20px;
                  margin-right: 8px;
                }
              }
            }
            .lackNumClass {
              height: 28px;
              font-size: 24px;

              font-weight: 400;
              color: #999999;
              line-height: 28px;
              span {
                height: 30px;
                font-size: 26px;
                font-weight: 600;
                color: #fe66a6;
                line-height: 30px;
                margin: 0px 4px;
              }
            }
          }

          .progressBox {
            width: 100%;
            height: 12px;
            background: #f5f5f5;
            border-radius: 16px;
            position: relative;
            margin-top: 16px;
            margin-bottom: 40px;
            .progressClass {
              position: absolute;
              height: 100%;
              background: #fe74ae;
              border-radius: 16px;
              display: inline-block;
              top: 0px;
              left: 0px;
            }
          }
        }

        .btnClass {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 40px;
          font-size: 30px;
          font-weight: 400;
          color: #333333;
          line-height: 40px;

          img {
            width: 30px;
            height: 30px;
            margin-right: 16px;
          }
        }
      }
    }
  }

  .fixBox {
    width: calc(100% - 40px);
    height: 124px;
    background-image: url("https://img.bbalt.cn/imgh5/donate/bg_fix.png");
    background-repeat: no-repeat;
    background-size: 100% 124px;
    margin: 0px 20px;
    position: fixed;
    bottom: 170px;
    .titleBox {
      margin-top: 23px;
      margin-left: 52px;
      height: 40px;
      font-size: 30px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 40px;
      text-shadow: 0px -1px 16px rgba(0, 0, 0, 0.08);
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        &:first-child {
          width: 40px;
          height: 40px;
          margin-right: 8px;
        }
        &:last-child {
          width: 30px;
          height: 30px;
          margin-left: 24px;
        }
      }
    }
    p {
      margin-top: 9px;
      margin-left: 52px;
      height: 28px;
      font-size: 22px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 28px;
      text-shadow: 0px -1px 16px rgba(0, 0, 0, 0.08);
    }
  }
}
.noDataBox {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  img {
    width: 80%;
    margin: 30px auto;
  }
}
.van-loading {
  text-align: center;
}
</style>
